import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TypeOuiNon } from '../models/TypeOuiNon';
import { Step9 } from '../../../../shared/models/component-messages/blocCommun/simp/step9';

@Component({
  selector: 'app-type-oui-non',
  templateUrl: './type-oui-non.component.html'
})
export class TypeOuiNonComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeOuiNon'
  @Input() parentForm: FormGroup;
  @Input() disabled: boolean;
  
  	@Input() attributionSansNegociation : TypeOuiNon;

    public step9 = new Step9();

  constructor() { }

  public ngOnInit() {
  }
  
  
  
  
  
  

  
  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }  
  
  
}

